import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_i18n_number = _resolveComponent("i18n-number")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_ctx.scale && _ctx.scale.tare)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ion_grid, { "no-padding": "" }, {
          default: _withCtx(() => [
            (!_ctx.scale.tare.date)
              ? (_openBlock(), _createBlock(_component_ion_row, {
                  key: 0,
                  class: "ion-align-items-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_ion_label, { color: "danger" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare_missing")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            (_ctx.scale.tare.date)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { color: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_gross_weight")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { color: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, { size: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { color: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare_date")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { color: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare_hives")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { color: "primary" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare_last_hour")), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_i18n_number, {
                            value: _ctx.scale.tare.gross_weight,
                            fraction: 3
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_i18n_number, {
                            value: _ctx.scale.tare.weight || 0,
                            fraction: 3
                          }, null, 8 /* PROPS */, ["value"])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, { size: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.scale.tare.date, 'll')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.scale.tare.hives), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_ion_col, { size: "2" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_text, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.scale.tare.last_hour) + ":00", 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_5,
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editTare()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.i18n("details_scale_tare_action")), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      })
                    ])
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : _createCommentVNode("v-if", true)
}